import { DataItem } from './@types';

export const getSum = (chartData: DataItem[]) => {
  const maxDataArray = chartData.toSorted((a, b) => b.data.length - a.data.length)[0]?.data;
  return maxDataArray?.map((_, index) => chartData.reduce((prev, cur) => prev + (cur.data[index] || 0), 0)) || [];
};

export const getCoordinates = (totalData: number[], chartData: DataItem[], width: number, height: number) => {
  const totalLength = totalData.length;
  const maxValue = totalData.toSorted((a, b) => b - a)[0];

  return totalData.map((totalValue, dataIndex) => ({
    x: (dataIndex / (totalLength - 1)) * width,
    y: chartData
    .map((item) => item.data[dataIndex])
    .reduce<{ y1: number; y2: number }[]>((prev, cur) => {
      const prevY2 = prev.at(-1)?.y2 ?? (height - (totalValue / maxValue) * height) / 2;
      const currentHeight = (cur / maxValue) * height;
      return [
        ...prev,
        {
          y1: prevY2,
          y2: prevY2 + currentHeight,
        },
      ];
    }, []),
  }));
};

export const getPathData = (coordinates: ReturnType<typeof getCoordinates>, dataIndex: number) => {
  return `M
    ${coordinates.map((item, index) =>`${index ? 'L' : ''} ${item.x} ${item.y[dataIndex].y1}`).join(' ')}
    ${coordinates.reverse().map((item) => `L${item.x} ${item.y[dataIndex].y2}`).join(' ')}
  Z`;
};

export const copyLastValue = (data: number[]) => {
  return data.concat(data[data.length - 1]);
};